import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
domain="optimus-cuhk.us.auth0.com"
clientId="BNQRSTD8MCf6uxCur3Hv2JHf4CuzF6fH"
authorizationParams={{
  redirect_uri: window.location.origin, 
}}
cacheLocation="memory" // Changes from localStorage to memory storage
useRefreshTokens={true} // Enables silent authentication
useRefreshTokensFallback={true} // Ensures it works in all browsers
>
<React.StrictMode>
<App />
</React.StrictMode>

</Auth0Provider>, 
// document. getElementById('root')
);

